





























































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  Alert,
  AlertMessage,
  AuthUser,
  defaultSystemCode,
  ErrorMessage,
  placeChangeApi
} from '@/api'
import {
  PAGE_LOADING_END,
  PAGE_LOADING_START,
  CHANGED_PROCESS_PLACE
} from '@/config/event'
import {
  alertStore,
  authUserStore,
  dataStore,
  modalErrorStore,
  modalProcessPlaceChangeStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { InputCode } from '@/components/molecules/InputCode'
import { AlertCodeAL300032 } from '@/types'
import { CODE_KEY } from '@/config'

interface ModalProcessPlaceChangeInputItem {
  branchCode: {
    input: string
    errorMessage: string
  }
  placeCode: {
    input: string
    errorMessage: string
  }
}

const defaultModalProcessPlaceChangeInputItem = (): ModalProcessPlaceChangeInputItem => ({
  branchCode: {
    input: '',
    errorMessage: ''
  },
  placeCode: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    ModalFooter
  }
})
export default class ModalProcessPlaceChange extends ComponentVue {
  @Ref()
  branchCodeInputCode!: InputCode

  inputItem: ModalProcessPlaceChangeInputItem = defaultModalProcessPlaceChangeInputItem()

  get authUser(): AuthUser {
    return authUserStore.authUser
  }

  get isOpen(): boolean {
    return modalProcessPlaceChangeStore.isOpen
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.LIBRARY_BRANCH.KEY,
        CODE_KEY.PROCESSING_PLACE.KEY
      ])

      this.inputItem = {
        branchCode: {
          input: this.authUser.branchCode.code,
          errorMessage: ''
        },
        placeCode: {
          input: this.authUser.placeCode.code,
          errorMessage: ''
        }
      }

      this.$nextTick(() => {
        setTimeout(this.focusBranchCodeInputCode)
      })

      return
    }

    this.inputItem = defaultModalProcessPlaceChangeInputItem()
  }

  close(): void {
    modalProcessPlaceChangeStore.close()
  }

  focusBranchCodeInputCode(): void {
    this.branchCodeInputCode.textField.atomTextField.focus()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async changeProcessPlace(_force: boolean): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await placeChangeApi.changeProcessPlace({
        branchCode: this.inputItem.branchCode.input,
        placeCode: this.inputItem.placeCode.input,
        _force
      })
      await dataStore.fetch()

      authUserStore.setAuthUserBranchCode(
        systemCodeStore.getLibraryBranch.find(
          systemCode => systemCode.code === this.inputItem.branchCode.input
        ) ?? defaultSystemCode()
      )
      authUserStore.setAuthUserPlaceCode(
        systemCodeStore.getPlaceCode.find(
          systemCode => systemCode.code === this.inputItem.placeCode.input
        ) ?? defaultSystemCode()
      )

      this.close()
      this.$eventBus.emit(CHANGED_PROCESS_PLACE)
    } catch (error) {
      this.setErrorMessage(error.alerts, this.inputItem)
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeAL300032
        ) {
          alertStore.setItem(error.alerts[0])
          this.$modalAlert.open({
            onOkClick: () => {
              this.changeProcessPlace(true)
            }
          })
          return
        }
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
